import { Directive } from '@angular/core';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import { getPeriodicityLabel } from 'src/app/_enums/proposal.enums';
import { PolicyUpdateMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class PolicyUpdateMetadataComponentAbstract extends BaseMetadataComponent<PolicyUpdateMetadata> {
  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getPeriodicityLabel = getPeriodicityLabel;
}
